import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Avatar, Typography, Box, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const AgenciesTableRow = ({
    agency,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(agency.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, agency.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* العنوان مع الصورة */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {agency.image && (
                        <Avatar
                            src={agency.image}
                            alt={agency.title}
                            sx={{ width: 60, height: 40 }}
                            variant="rounded"
                        />
                    )}
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {isArabic
                                ? (agency?.title?.ar || agency?.title?.en || (typeof agency?.title === 'string' ? agency.title : '-'))
                                : (agency?.title?.en || agency?.title?.ar || (typeof agency?.title === 'string' ? agency.title : '-'))
                            }
                        </Typography>
                    </Box>
                </Box>
            </TableCell>

            {/* العنوان الفرعي */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {isArabic
                    ? (agency?.sub_title?.ar || agency?.sub_title?.en || (typeof agency?.sub_title === 'string' ? agency.sub_title : '-'))
                    : (agency?.sub_title?.en || agency?.sub_title?.ar || (typeof agency?.sub_title === 'string' ? agency.sub_title : '-'))
                }
            </TableCell>

            {/* الحالة */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                <Chip
                    label={agency?.is_active ? (isArabic ? 'مفعّل' : 'Active') : (isArabic ? 'معطّل' : 'Inactive')}
                    color={agency?.is_active ? 'success' : 'default'}
                    size="small"
                    variant="outlined"
                />
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {agency?.created_at ? dayjs(agency.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, agency)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default AgenciesTableRow;
